export const translations = {
  en: {
    // Header
    nav: {
      home: 'Home',
      services: 'Services',
      pricing: 'Pricing',
      booking: 'Booking',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    
    // Hero Section
    hero: {
      title: 'Private medical services in family and general medicine in Gothenburg.',
      subtitle: 'Ambulanta Care offers private home visits and video consultations, available in the evening and at night, with a licensed doctor and a licensed district nurse. Your medical records and medical history are kept private and are not accessible to other healthcare providers. Ambulanta Care operates independently and is not affiliated with the public regional healthcare system. Laboratory tests can be ordered upon request and are carried out through Synlab at an additional cost.',
      languages: 'Consultations available in Swedish, English and Serbo‑Croatian.',
      bookAppointment: 'Book Appointment',
      learnMore: 'Learn More',
      callUs: 'Call us today'
    },
    
    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive medical care tailored to your needs, available at your home or via secure video consultation',
      items: [
        {
          title: 'Family Medicine',
          description: 'Comprehensive medical care for the whole family, with focus on continuity and a long‑term doctor–patient relationship.'
        },
        {
          title: 'General Medicine',
          description: 'Diagnosis and treatment of acute and chronic conditions in adults, including cardiovascular and metabolic diseases, thyroid disorders and obesity.'
        },
        {
          title: 'Home Visit Services',
          description: 'Private medical consultations and examinations in the patient\'s home for those with reduced mobility or who prefer care at home.'
        },
        {
          title: 'Video Consultations',
          description: 'Secure online consultations for follow‑up of chronic conditions, medical advice, second opinions and prescription management when a physical visit is not necessary.'
        },
        {
          title: 'Health Checks',
          description: 'Structured health assessments with clinical examination and targeted blood tests to evaluate your general health and to prevent future disease.'
        },
        {
          title: 'Medical Certificates and Sick Leave',
          description: 'Various medical certificates and sick leave certificates, with sick leave up to 4 weeks depending on the condition. We do not renew long‑term sick leave certificates.'
        }
      ],
      conditionsTitle: 'Management of Common Conditions',
      conditionsDescription: 'We manage a wide range of common conditions, including cardiovascular risk factors (hypertension, high cholesterol), type 2 diabetes, hypothyroidism, obesity, chronic migraine and other headaches, asthma, mild COPD, anxiety, sleep problems, gastrointestinal and musculoskeletal complaints.',
      conditionsDescription2: 'This includes acute infections such as respiratory and urinary tract infections, acute ear infections, sore throat including tonsillitis and sinusitis, as well as eye and simple gynaecological infections.'
    },
    
    // Extra Services Section
    extraServices: {
      title: 'Extra Services',
      subtitle: 'Specialized services for comprehensive health assessment and expert medical opinions',
      items: [
        {
          title: 'Health Checks',
          description: 'Comprehensive health checks including medical history, physical examination and tailored blood tests to assess cardiovascular, metabolic and general health status.'
        },
        {
          title: 'Second Opinion on Diagnoses and Tests',
          description: 'Second medical opinion on existing diagnoses, treatment plans and blood test results, to provide clarity, reassurance and alternative options where appropriate.'
        },
        {
          title: 'Blood Test Review and Follow‑up',
          description: 'On‑site testing of infectious parameters such as CRP and procalcitonin, as well as TSH when indicated. Detailed review of your laboratory results, explanation in clear language and planning of further investigations or treatment when needed.'
        }
      ]
    },
    
    // Second Opinion Block
    secondOpinion: {
      title: 'Second Opinions and Blood Test Review',
      description: 'On‑site testing of infectious parameters (CRP, PCT) and TSH. We offer independent second opinions on existing diagnoses and treatment plans, as well as detailed review and explanation of your blood test results. This service can be provided via video consultation or as a home visit.',
      languages: 'Consultations available in Swedish, English and Serbo‑Croatian.'
    },
    
    // Pricing Section
    pricing: {
      title: 'Transparent Pricing',
      subtitle: 'Clear, upfront pricing with no hidden fees',
      items: [
        {
          title: 'Home Visit',
          oldPrice: '2000 SEK',
          price: '1000 SEK',
          oldPriceEvening: '2500 SEK',
          priceEvening: '1250 SEK',
          duration: 'until 20:00 / 20:00-04:00',
          discount: '50% OFF',
          description: 'Clinical assessment, diagnostics and treatment included'
        },
        {
          title: 'Video Consultation',
          oldPrice: '1000 SEK',
          price: '750 SEK',
          duration: 'per consultation',
          discount: '25% OFF',
          description: 'Up to 60 minutes'
        },
        {
          title: 'Prescription Renewal',
          price: '50 SEK',
          duration: 'per medication',
          description: 'Quick and convenient'
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: 'Book Your Appointment',
      subtitle: 'Schedule a home visit or video consultation at your convenience'
    },
    
    // Contact Section
    contact: {
      title: 'Get In Touch',
      subtitle: 'We\'re here to answer your questions and provide the care you need',
      phone: 'Phone',
      email: 'Email',
      address: 'Service Area',
      addressText: 'We come to you in the Gothenburg area.'
    },
    
    // Footer
    footer: {
      description: 'Ambulanta Care – Private medical services in family and general medicine in Gothenburg.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Info',
      location: 'Gothenburg',
      copyright: 'All rights reserved.'
    }
  },
  
  sv: {
    // Header
    nav: {
      home: 'Hem',
      services: 'Tjänster',
      pricing: 'Priser',
      booking: 'Bokning',
      contact: 'Kontakt',
      bookNow: 'Boka nu'
    },
    
    // Hero Section
    hero: {
      title: 'Privat medicinsk vård inom allmänmedicin och familjemedicin i Göteborg.',
      subtitle: 'Ambulanta Care erbjuder privata hembesök och videokonsultationer, tillgängliga kvälls- och nattetid, med legitimerad läkare och legitimerad distriktssköterska. Dina medicinska journaler och din medicinska historia hanteras konfidentiellt och är inte åtkomliga för andra vårdgivare. Ambulanta Care är inte ansluten till den offentliga vården. Provtagning kan beställas enligt önskemål och utförs via Synlab mot tillkommande kostnad.',
      languages: 'Konsultationer erbjuds på svenska, engelska och serbokroatiska.',
      bookAppointment: 'Boka tid',
      learnMore: 'Läs mer',
      callUs: 'Ring oss idag'
    },
    
    // Services Section
    services: {
      title: 'Våra tjänster',
      subtitle: 'Omfattande medicinsk vård anpassad efter dina behov, tillgänglig i ditt hem eller via säker videokonsultation',
      items: [
        {
          title: 'Familjemedicin',
          description: 'Helhetsinriktad medicinsk vård för hela familjen, med fokus på kontinuitet och en långsiktig patient–läkarrelation.'
        },
        {
          title: 'Allmänmedicin',
          description: 'Utredning och behandling av akuta och kroniska sjukdomstillstånd hos vuxna, inklusive hjärt‑kärlsjukdom, metabola tillstånd, sköldkörtelsjukdom och obesitas.'
        },
        {
          title: 'Hembesök',
          description: 'Privata medicinska konsultationer och undersökningar i patientens hem för personer med nedsatt rörlighet eller som föredrar vård i hemmet.'
        },
        {
          title: 'Videokonsultationer',
          description: 'Säkra videobesök för uppföljning av kroniska sjukdomar, medicinsk rådgivning, second opinion och receptförnyelse när ett fysiskt besök inte är nödvändigt.'
        },
        {
          title: 'Hälsokontroll',
          description: 'Strukturerade hälsoundersökningar med klinisk undersökning och riktade blodprover för att bedöma allmänt hälsotillstånd och förebygga framtida sjukdom.'
        },
        {
          title: 'Läkarintyg och sjukskrivning',
          description: 'Olika läkarintyg och sjukintyg, med sjukskrivning upp till 4 veckor beroende på tillstånd. Vi förnyar inte långvariga sjukskrivningar.'
        }
      ],
      conditionsTitle: 'Vanliga tillstånd vi behandlar',
      conditionsDescription: 'Vi behandlar ett brett spektrum av vanliga tillstånd, inklusive hjärt‑kärlsriskfaktorer (hypertoni, förhöjda blodfetter), diabetes mellitus typ 2, hypotyreos, obesitas, kronisk migrän och andra huvudvärkstillstånd, astma, mild KOL, ångest, lätt–måttlig depression, sömnproblem, gastrointestinala besvär och muskuloskeletala besvär.',
      conditionsDescription2: 'Detta inkluderar akuta infektioner såsom luftvägs‑ och urinvägsinfektioner, akuta öroninflammationer, halsont inklusive tonsillit och sinuit, samt ögon‑ och enklare gynekologiska infektioner.'
    },
    
    // Extra Services Section
    extraServices: {
      title: 'Extra tjänster',
      subtitle: 'Specialiserade tjänster för omfattande hälsobedömning och expertmedicinska åsikter',
      items: [
        {
          title: 'Hälsokontroll',
          description: 'Omfattande hälsokontroller med anamnes, status och individanpassade blodprover för att bedöma kardiovaskulär, metabol och allmän hälsa.'
        },
        {
          title: 'Second opinion vid diagnos och prover',
          description: 'Medicinsk second opinion på befintlig diagnos, behandlingsplan och laboratorieprover, för att skapa tydlighet, trygghet och eventuella alternativa behandlingsstrategier.'
        },
        {
          title: 'Provsvaret genomgång och uppföljning',
          description: 'På plats kan vi analysera infektionsparametrar såsom CRP och prokalcitonin samt TSH vid behov. Vi går igenom dina laboratorieresultat, förklarar dem på ett tydligt sätt och planerar vidare utredning eller behandling vid behov.'
        }
      ]
    },
    
    // Second Opinion Block
    secondOpinion: {
      title: 'Second opinion och genomgång av provsvar',
      description: 'På plats kan vi analysera infektionsparametrar (CRP, PCT) och TSH. Vi erbjuder oberoende second opinion på befintliga diagnoser och behandlingsplaner samt en detaljerad genomgång och förklaring av dina provsvar. Tjänsten kan erbjudas via videokonsultation eller hembesök.',
      languages: 'Konsultationer erbjuds på svenska, engelska och serbokroatiska.'
    },
    
    // Pricing Section
    pricing: {
      title: 'Tydliga priser',
      subtitle: 'Klara priser utan dolda avgifter',
      items: [
        {
          title: 'Hembesök',
          oldPrice: '2000 SEK',
          price: '1000 SEK',
          oldPriceEvening: '2500 SEK',
          priceEvening: '1250 SEK',
          duration: 'till 20:00 / 20:00-04:00',
          discount: '50% RABATT',
          description: 'Klinisk bedömning, diagnostik och behandling ingår'
        },
        {
          title: 'Videokonsultation',
          oldPrice: '1000 SEK',
          price: '750 SEK',
          duration: 'per konsultation',
          discount: '25% RABATT',
          description: 'Upp till 60 minuter'
        },
        {
          title: 'Receptförnyelse',
          price: '50 SEK',
          duration: 'per läkemedel',
          description: 'Snabbt och smidigt'
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: 'Boka din tid',
      subtitle: 'Schemalägg ett hembesök eller videokonsultation när det passar dig'
    },
    
    // Contact Section
    contact: {
      title: 'Kontakta oss',
      subtitle: 'Vi finns här för att svara på dina frågor och ge dig den vård du behöver',
      phone: 'Telefon',
      email: 'E-post',
      address: 'Tjänsteområde',
      addressText: 'Vi kommer hem till dig i Göteborgsområdet.'
    },
    
    // Footer
    footer: {
      description: 'Ambulanta Care – Private medical services in family and general medicine in Gothenburg.',
      quickLinks: 'Snabblänkar',
      contactInfo: 'Kontaktinformation',
      location: 'Göteborg',
      copyright: 'Alla rättigheter förbehållna.'
    }
  },
  
  sr: {
    // Header
    nav: {
      home: 'Početna',
      services: 'Usluge',
      pricing: 'Cene',
      booking: 'Zakazivanje',
      contact: 'Kontakt',
      bookNow: 'Zakažite'
    },
    
    // Hero Section
    hero: {
      title: 'Privatne medicinske usluge iz porodične i opšte medicine u Geteborgu.',
      subtitle: 'Ambulanta Care nudi privatne kućne posete i video-konsultacije, dostupne uveče i noću, sa licenciranim lekarom i licenciranom patronažnom medicinskom sestrom. Vaši medicinski zapisi i medicinska istorija čuvaju se poverljivo i nisu dostupni drugim zdravstvenim ustanovama. Ambulanta Care posluje nezavisno i nije povezana sa javnim regionalnim zdravstvenim sistemom. Laboratorijske analize mogu se naručiti po želji i obavljaju se preko Synlab-a uz dodatnu naknadu.',
      languages: 'Konsultacije su dostupne na švedskom, engleskom i srpskom.',
      bookAppointment: 'Zakažite termin',
      learnMore: 'Saznajte više',
      callUs: 'Pozovite nas danas'
    },
    
    // Services Section
    services: {
      title: 'Naše usluge',
      subtitle: 'Sveobuhvatna medicinska nega prilagođena vašim potrebama, dostupna u vašem domu ili putem bezbedne video konsultacije',
      items: [
        {
          title: 'Porodična medicina',
          description: 'Sveobuhvatna medicinska briga za celu porodicu, sa naglaskom na kontinuitet i dugoročan odnos lekar–pacijent.'
        },
        {
          title: 'Opšta medicina',
          description: 'Dijagnostika i lečenje akutnih i hroničnih oboljenja kod odraslih, uključujući kardiovaskularne i metaboličke bolesti, poremećaje štitaste žlezde i gojaznost.'
        },
        {
          title: 'Kućne posete',
          description: 'Privatni lekarski pregledi i konsultacije u domu pacijenta, za osobe sa smanjenom pokretljivošću ili one koji više vole da dobiju negu kod kuće.'
        },
        {
          title: 'Video konsultacije',
          description: 'Bezbedne onlajn konsultacije za praćenje hroničnih oboljenja, medicinski savet, drugo mišljenje i regulisanje terapije i recepata kada fizička poseta nije neophodna.'
        },
        {
          title: 'Sistematski pregledi',
          description: 'Strukturisani sistematski pregledi sa kliničkim pregledom i ciljanim laboratorijskim analizama, radi procene opšteg zdravstvenog stanja i prevencije budućih bolesti.'
        },
        {
          title: 'Lekarska uverenja i bolovanja',
          description: 'Različita lekarska uverenja i potvrde o bolovanju, sa bolovanjem do 4 nedelje u zavisnosti od stanja. Ne produžavamo dugotrajna bolovanja.'
        }
      ],
      conditionsTitle: 'Stanja koja najčešće lečimo',
      conditionsDescription: 'Lečimo širok spektar uobičajenih oboljenja, uključujući faktore rizika za kardiovaskularne bolesti (povišen krvni pritisak, povišene masnoće), dijabetes tip 2, hipotireozu, gojaznost, hroničnu migrenu i druge glavobolje, astmu, blagu KOPB, anksioznost, blaže do umerene depresije, poremećaje spavanja, gastrointestinalne tegobe i muskuloskeletne bolove.',
      conditionsDescription2: 'To uključuje i akutne infekcije kao što su respiratorne i urinarne infekcije, akutne upale uha, bol u grlu uključujući anginu i sinusitis, kao i infekcije oka i jednostavnije ginekološke infekcije.'
    },
    
    // Extra Services Section
    extraServices: {
      title: 'Dodatne usluge',
      subtitle: 'Specijalizovane usluge za sveobuhvatnu procenu zdravlja i stručna medicinska mišljenja',
      items: [
        {
          title: 'Sistematski pregledi',
          description: 'Sveobuhvatni pregledi koji uključuju anamnezu, fizikalni pregled i ciljane laboratorijske analize radi procene kardiovaskularnog, metaboličkog i opšteg zdravstvenog stanja.'
        },
        {
          title: 'Drugo mišljenje za dijagnoze i nalaze',
          description: 'Drugo medicinsko mišljenje o postojećim dijagnozama, terapijskim planovima i laboratorijskim nalazima, sa ciljem da se obezbede jasnoća, sigurnost i eventualne alternativne opcije lečenja.'
        },
        {
          title: 'Tumačenje laboratorijskih nalaza i praćenje',
          description: 'Na licu mesta možemo uraditi brze testove na infektivne parametre kao što su CRP i prokalcitonin, kao i TSH kada je potrebno. Detaljno prolazimo kroz vaše laboratorijske rezultate, objašnjavamo ih razumljivim jezikom i planiramo dalje ispitivanje ili terapiju po potrebi.'
        }
      ]
    },
    
    // Second Opinion Block
    secondOpinion: {
      title: 'Drugo mišljenje i analiza laboratorijskih nalaza',
      description: 'Na licu mesta radimo testove infektivnih parametara (CRP, PCT) i TSH. Nudimo nezavisno drugo mišljenje o postojećim dijagnozama i terapijama, kao i detaljno objašnjenje vaših nalaza. Ova usluga je dostupna putem video konsultacije ili kućne posete.',
      languages: 'Konsultacije su dostupne na švedskom, engleskom i srpskom.'
    },
    
    // Pricing Section
    pricing: {
      title: 'Transparentne cene',
      subtitle: 'Jasne cene bez skrivenih troškova',
      items: [
        {
          title: 'Kućna poseta',
          oldPrice: '2000 SEK',
          price: '1000 SEK',
          oldPriceEvening: '2500 SEK',
          priceEvening: '1250 SEK',
          duration: 'do 20:00 / 20:00-04:00',
          discount: '50% POPUST',
          description: 'Klinička procena, dijagnostika i lečenje uključeni'
        },
        {
          title: 'Video konsultacija',
          oldPrice: '1000 SEK',
          price: '750 SEK',
          duration: 'po konsultaciji',
          discount: '25% POPUST',
          description: 'Do 60 minuta'
        },
        {
          title: 'Obnova recepta',
          price: '50 SEK',
          duration: 'po leku',
          description: 'Brzo i praktično'
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: 'Zakažite svoj termin',
      subtitle: 'Zakažite kućnu posetu ili video konsultaciju kada vama odgovara'
    },
    
    // Contact Section
    contact: {
      title: 'Kontaktirajte nas',
      subtitle: 'Tu smo da odgovorimo na vaša pitanja i pružimo vam potrebnu negu',
      phone: 'Telefon',
      email: 'E-pošta',
      address: 'Područje usluga',
      addressText: 'Dolazimo kod vas na području Geteborga.'
    },
    
    // Footer
    footer: {
      description: 'Ambulanta Care – Private medical services in family and general medicine in Gothenburg.',
      quickLinks: 'Brzi linkovi',
      contactInfo: 'Kontakt informacije',
      location: 'Geteborg',
      copyright: 'Sva prava zadržana.'
    }
  }
};
